import { ref, push, set, get, remove, update } from 'firebase/database';
import { db } from '../lib/firebase';

export const createEstimate = async (userId: string, data: EstimateData): Promise<string> => {
  const estimatesRef = ref(db, `estimates/${userId}`);
  const newEstimateRef = push(estimatesRef);

  const { id: _, ...cleanData } = data as any;

  const estimateData = {
    ...cleanData,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    status: 'draft'
  };

  await set(newEstimateRef, estimateData);
  return newEstimateRef.key as string;
};

export const getEstimates = async (userId: string): Promise<EstimateWithId[]> => {
  const estimatesRef = ref(db, `estimates/${userId}`);
  const snapshot = await get(estimatesRef);
  
  console.log('=== GET ESTIMATES ===');
  console.log('Snapshot exists:', snapshot.exists());
  console.log('Snapshot val:', snapshot.val());
  
  if (!snapshot.exists()) {
    return [];
  }
  
  const estimates = Object.entries(snapshot.val()).map(([id, data]) => {
    const { id: _, ...cleanData } = data as any;
    return {
      ...cleanData,
      id
    };
  });
  
  console.log('Estimates chargées:', estimates.map(e => e.id));
  
  return estimates;
};

export const getEstimate = async (userId: string, estimateId: string): Promise<EstimateData | null> => {
  const estimateRef = ref(db, `estimates/${userId}/${estimateId}`);
  const snapshot = await get(estimateRef);
  
  if (!snapshot.exists()) {
    return null;
  }
  
  return snapshot.val() as EstimateData;
};

export const updateEstimate = async (userId: string, estimateId: string, data: Partial<EstimateData>): Promise<void> => {
  const estimateRef = ref(db, `estimates/${userId}/${estimateId}`);

  const snapshot = await get(estimateRef);

  if (!snapshot.exists()) {
    throw new Error('Estimation non trouvée');
  }

  const existingData = snapshot.val() as EstimateData;

  let type = existingData.type || data.type;
  if (!type) {
    const detailedCategories = [
      'preparation', 'demolition', 'gros-oeuvre', 'vrd',
      'isolation', 'cloisons', 'technique', 'sanitaire',
      'revetements', 'menuiserie', 'finitions', 'exterieurs'
    ];

    const hasDetailedCategories = detailedCategories.some(
      category => existingData[category as keyof EstimateData] !== undefined
    );

    if (hasDetailedCategories) {
      type = 'detailed';
    } else {
      const hasQuickFields =
        (existingData as any).propertyType !== undefined &&
        (existingData as any).area !== undefined &&
        (existingData as any).renovationLevel !== undefined;

      type = hasQuickFields ? 'quick' : 'detailed';
    }
  }

  const createdAt = existingData.createdAt || new Date().toISOString();

  const { id: _1, ...cleanExisting } = existingData as any;
  const { id: _2, ...cleanData } = data as any;

  const completeData = {
    ...cleanExisting,
    ...cleanData,
    type,
    createdAt,
    updatedAt: new Date().toISOString()
  };

  console.log('=== UPDATE ESTIMATE ===');
  console.log('Path:', `estimates/${userId}/${estimateId}`);
  console.log('Type détecté:', type);
  console.log('Champs ajoutés:', { type, createdAt, updatedAt: completeData.updatedAt });

  await set(estimateRef, completeData);
};

export const deleteEstimate = async (userId: string, estimateId: string): Promise<void> => {
  const estimateRef = ref(db, `estimates/${userId}/${estimateId}`);
  await remove(estimateRef);
};

export const saveEstimate = async (userId: string, data: EstimateData): Promise<string> => {
  return createEstimate(userId, data);
};